/* Final-sale label tidy-up.
 *
 * Shipped as an ASSET, not an inline <script>, on purpose: the storefront runs an
 * HTML-optimisation app that cached the inline version and kept serving a stale
 * copy for 20+ minutes after deploy. Asset URLs are emitted by Liquid with a
 * ?v=<hash> that changes on every upload, so a deploy always reaches the browser.
 *
 * Rendered by snippets/final-sale-display.liquid.
 * Bump __fsVersion on every change so a deploy can be verified from the page.
 */
(function(){var css="\n  .fs-tag {\n    display: inline-block;\n    margin-top: 4px;\n    padding: 3px 8px;\n    border: 1px solid #d64b1f;\n    border-left-width: 3px;\n    border-radius: 3px;\n    background: #fff6f2;\n    color: #a33c17;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.35;\n    white-space: normal;\n  }\n  .fs-tag--block { display: block; width: -moz-fit-content; width: fit-content; }\n  .fs-dupe-hidden { display: none !important; }\n  .fs-swatch-note {\n    display: block;\n    margin-top: 1px;\n    color: #d64b1f;\n    font-size: 9px;\n    font-weight: 700;\n    line-height: 1.1;\n    letter-spacing: .03em;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n";function add(){if(document.getElementById('fs-display-css'))return;var s=document.createElement('style');s.id='fs-display-css';s.textContent=css;(document.head||document.documentElement).appendChild(s);}if(document.head)add();else document.addEventListener('DOMContentLoaded',add);})();

(function () {
  if (window.__fsDisplay) return;
  window.__fsDisplay = true;
  window.__fsVersion = 3; // bump on every change; lets a deploy be verified from the page

  var SUFFIX = /\s*-\s*SALE IS FINAL RETURNS EXCLUDED\s*/i;
  var SUFFIX_G = /\s*-\s*SALE IS FINAL RETURNS EXCLUDED\s*/gi;
  var TAG_TEXT = 'Final sale — no returns or exchanges';
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, TEMPLATE: 1 };

  function hasSuffix(s) { return SUFFIX.test(s || ''); }

  // Replace with a SPACE, not an empty string. The suffix sits mid-string in
  // places like "Olive / 10 - SALE IS FINAL RETURNS EXCLUDED - $15.95", and the
  // bundle widget (assets/custom.js) parses that option text by splitting on
  // ' - ' to separate title from price. Deleting the suffix outright welds the
  // separator to the price ("10- $15.95") and the price parse yields NaN.
  // Collapsing to one space keeps the "Title - $Price" shape intact.
  function strip(s) {
    return (s || '')
      .replace(SUFFIX_G, ' ')
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/\s*\/\s*$/, '')
      .trim();
  }

  // ---- cart lines: badge, then trim -------------------------------------
  // Must run BEFORE the generic trim, since it keys off the suffix being present.
  function doCartBadges(scope) {
    try {
      scope.querySelectorAll('.mini-cart__product-title, .line-item__title').forEach(function (el) {
        if (!hasSuffix(el.textContent)) return;
        el.textContent = strip(el.textContent);
        var host = el.parentNode;
        if (!host || host.querySelector('.fs-tag')) return;
        var tag = document.createElement('span');
        tag.className = 'fs-tag';
        tag.textContent = TAG_TEXT;
        host.insertBefore(tag, el.nextSibling);
      });
    } catch (e) {}
  }

  // Small orange "FINAL SALE" line inside the swatch itself, so the shopper can
  // see which sizes carry the condition without opening anything.
  function markSwatch(item, isFinal) {
    var label = item.querySelector('label');
    if (!label) return;
    var note = label.querySelector('.fs-swatch-note');
    if (isFinal && !note) {
      note = document.createElement('span');
      note.className = 'fs-swatch-note';
      note.textContent = 'Final sale';
      label.appendChild(note);
    } else if (!isFinal && note) {
      note.parentNode.removeChild(note);
    }
  }

  // ---- bundle rows ------------------------------------------------------
  // The bundle widget builds its title with html().split(' - ')[0], so the
  // suffix is already gone by the time we see it and there is no text to match
  // on. Identify final-sale rows by variant id instead: final-sale-notice.liquid
  // publishes the product's final-sale variant ids, and a bundle only ever holds
  // variants of the product being viewed.
  function finalSaleIds() {
    var ids = {};
    document.querySelectorAll('[data-final-sale-notice]').forEach(function (box) {
      (box.getAttribute('data-final-sale-ids') || '').split(',').forEach(function (s) {
        s = s.trim();
        if (s) ids[s] = true;
      });
    });
    return ids;
  }

  function doBundleBadges(scope) {
    try {
      var root = scope.querySelectorAll ? scope : document;
      var rows = root.querySelectorAll('.bundle-item-wrapper');
      if (!rows.length) return;
      var ids = finalSaleIds();

      rows.forEach(function (row) {
        var title = row.querySelector('.bundle-item-title');
        if (!title) return;

        // The /cart.js path uses the raw variant_title, so it can still carry it.
        var fromText = hasSuffix(title.textContent);
        if (fromText) title.textContent = strip(title.textContent);

        var isFinal = fromText || !!ids[String(row.getAttribute('data-variant') || '').trim()];
        var existing = title.querySelector('.fs-tag');

        if (isFinal && !existing) {
          var tag = document.createElement('span');
          // Nested inside the title cell, not appended as a sibling: the row is
          // display:flex, so a sibling would become another flex item.
          tag.className = 'fs-tag fs-tag--block';
          tag.textContent = TAG_TEXT;
          title.appendChild(tag);
        } else if (!isFinal && existing) {
          existing.parentNode.removeChild(existing);
        }
      });
    } catch (e) {}
  }

  // ---- swatch duplicate resolution --------------------------------------
  // Groups by the radio's VALUE attribute, so it is unaffected by text trimming.
  function doSwatchGroup(list, itemSel, disabledClass) {
    var items = Array.prototype.slice.call(list.querySelectorAll(itemSel));
    if (!items.length) return;
    var byLabel = {};

    items.forEach(function (item) {
      var radio = item.querySelector('input[type="radio"]');
      if (!radio) return;
      var label = strip(radio.value);
      var isFinal = hasSuffix(radio.value);
      item.classList.toggle('fs-final-swatch', isFinal);
      markSwatch(item, isFinal);
      (byLabel[label] = byLabel[label] || []).push({
        el: item,
        isFinal: hasSuffix(radio.value),
        disabled: item.classList.contains(disabledClass)
      });
    });

    Object.keys(byLabel).forEach(function (label) {
      var group = byLabel[label];
      group.forEach(function (g) { g.el.classList.remove('fs-dupe-hidden'); });
      if (group.length < 2) return;

      var live = group.filter(function (g) { return !g.disabled; });

      if (live.length === 1) {
        // One twin is buyable for the current selection: hide the other.
        group.forEach(function (g) { if (g.disabled) g.el.classList.add('fs-dupe-hidden'); });
      } else if (live.length === 0) {
        // Neither is buyable: keep one so the size still shows as unavailable.
        group.slice(1).forEach(function (g) { g.el.classList.add('fs-dupe-hidden'); });
      }
      // If both are buyable at once — the genuinely ambiguous case — both stay
      // visible and the "Final sale" note already distinguishes them.
    });
  }

  function doSwatches(scope) {
    try {
      scope.querySelectorAll('.block-swatch-list').forEach(function (l) {
        doSwatchGroup(l, '.block-swatch', 'block-swatch--disabled');
      });
      scope.querySelectorAll('.variant-swatch-list').forEach(function (l) {
        doSwatchGroup(l, '.variant-swatch', 'variant-swatch--disabled');
      });
      scope.querySelectorAll('.color-swatch-list').forEach(function (l) {
        doSwatchGroup(l, '.color-swatch', 'color-swatch--disabled');
      });
    } catch (e) {}
  }

  // ---- <select>: options can't be hidden, so duplicates get marked -------
  function doSelects(scope) {
    try {
      scope.querySelectorAll('select').forEach(function (sel) {
        var clean = {};
        Array.prototype.forEach.call(sel.options, function (o) {
          if (!hasSuffix(o.value)) clean[strip(o.value)] = true;
        });
        Array.prototype.forEach.call(sel.options, function (o) {
          if (!hasSuffix(o.value) || !hasSuffix(o.textContent)) return;
          var label = strip(o.textContent);
          o.textContent = clean[strip(o.value)] ? label + ' — final sale' : label;
        });
      });
    } catch (e) {}
  }

  // ---- generic catch-all: every remaining text node ----------------------
  function trimText(root) {
    if (!root || !root.ownerDocument && root.nodeType !== 9) return;
    try {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          var p = n.parentNode;
          if (!p || SKIP_TAGS[p.nodeName]) return NodeFilter.FILTER_REJECT;
          return hasSuffix(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });
      var hits = [], n;
      while ((n = walker.nextNode())) hits.push(n);
      hits.forEach(function (t) { t.nodeValue = strip(t.nodeValue); });

      root.querySelectorAll('[title]').forEach(function (el) {
        var v = el.getAttribute('title');
        if (hasSuffix(v)) el.setAttribute('title', strip(v));
      });
    } catch (e) {}
  }

  // ---- "Select size" prompt ---------------------------------------------
  // Changing colour makes the theme auto-select a variant the shopper never
  // chose, so the Size label would keep showing a stale size. Until they pick a
  // size, prompt instead. final-sale-notice.liquid reads the same flag.
  window.__fsSizeChosen = true;

  function optionName(opt) {
    var el = opt && opt.querySelector ? opt.querySelector('.product-form__option-name') : null;
    return el ? (el.textContent || '') : '';
  }

  function isColourOption(el) {
    var opt = el && el.closest ? el.closest('.product-form__option') : null;
    return !!opt && /^\s*colou?r\s*:/i.test(optionName(opt));
  }

  // Switching between a final-sale colour and a normal one leaves the Size
  // option holding a value from the OTHER value set ("8 - SALE IS FINAL..." vs
  // "8"), which matches no variant. theme.js then hits its `if (!newVariant)`
  // branch and hides .price-list outright, leaving a stale price on screen and
  // no add-to-cart. Carry the size across by matching the trimmed label.
  var remapping = false;
  var wantedSize = null; // the size label the shopper last chose, e.g. "12"

  function isSizeList(list) {
    var opt = list.closest ? list.closest('.product-form__option') : null;
    return !!opt && /^\s*size\s*:/i.test(optionName(opt));
  }

  // Select an ENABLED swatch whose trimmed label matches, in either value set.
  function selectSizeByLabel(label) {
    if (!label) return false;
    var lists = document.querySelectorAll('.block-swatch-list');
    for (var i = 0; i < lists.length; i++) {
      if (!isSizeList(lists[i])) continue;
      var match = Array.prototype.slice
        .call(lists[i].querySelectorAll('.block-swatch'))
        .filter(function (el) { return !el.classList.contains('block-swatch--disabled'); })
        .filter(function (el) {
          var r = el.querySelector('input[type="radio"]');
          return r && strip(r.value) === label;
        })[0];
      if (!match) continue;

      var radio = match.querySelector('input[type="radio"]');
      if (radio.checked) return true;
      remapping = true;
      try {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        remapping = false;
      }
      return true;
    }
    return false;
  }

  // Called after a colour change. Three outcomes, and conflating them is what
  // broke this before: a still-valid selection must be LEFT ALONE, only a
  // genuinely unusable one gets remapped, and only an unmappable one is flushed.
  function reconcileSize() {
    if (remapping) return;

    var checked = document.querySelector('.block-swatch-list .block-swatch__radio:checked');
    if (checked) {
      var item = checked.closest('.block-swatch');
      if (item && !item.classList.contains('block-swatch--disabled')) {
        wantedSize = strip(checked.value);
        window.__fsSizeChosen = true;
        return; // still valid for this colour — nothing to do
      }
    }

    // Invalid for this colour, or nothing selected because a previous colour
    // lacked it. Re-apply the size the shopper actually asked for.
    if (selectSizeByLabel(wantedSize || (checked ? strip(checked.value) : null))) {
      window.__fsSizeChosen = true;
      return;
    }

    flushSize();
  }

  // If the size can't be carried across (that size isn't offered in the new
  // colour), the theme leaves the old radio checked — so the swatch still looks
  // selected while the label says "Select size". Clear the selection so the UI
  // tells the truth, and blank the variant input so a stale variant can't be
  // added to cart from a state the shopper never chose.
  function flushSize() {
    try {
      document.querySelectorAll('.product-form__option').forEach(function (opt) {
        if (!/^\s*size\s*:/i.test(optionName(opt))) return;
        opt.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
      });
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (i) {
        i.value = '';
      });
    } catch (e) {}
    window.__fsSizeChosen = false;
  }

  function doSizePrompt(scope) {
    if (window.__fsSizeChosen !== false) return;
    try {
      var root = scope.querySelectorAll ? scope : document;
      root.querySelectorAll('.product-form__option').forEach(function (opt) {
        if (!/^\s*size\s*:/i.test(optionName(opt))) return;
        var val = opt.querySelector('.product-form__selected-value');
        if (val && val.textContent !== 'Select size') val.textContent = 'Select size';
      });
    } catch (e) {}
  }

  var running = false;
  function pass(scope) {
    if (running) return;
    running = true;
    try {
      doCartBadges(scope);
      doBundleBadges(scope);
      doSwatches(scope);
      doSelects(scope);
      trimText(scope);
      doSizePrompt(scope);
    } finally {
      running = false;
    }
  }
  function runAll() { pass(document); }

  // theme.js re-toggles --disabled inside its own change handler, so defer past it.
  document.addEventListener('change', function (e) {
    var t = e.target;
    var colourChanged = false;
    if (t && t.classList && t.classList.contains('product-form__single-selector')) {
      colourChanged = isColourOption(t);
      if (!colourChanged && !remapping) {
        // A real size pick — remember it so it can be re-applied after passing
        // through a colour that doesn't offer it.
        wantedSize = strip(t.value);
        window.__fsSizeChosen = true;
      }
    }
    // Deferred so theme.js has finished re-flagging which values are available.
    setTimeout(function () {
      if (colourChanged) reconcileSize();
      runAll();
    }, 0);
  }, true);
  document.addEventListener('variant:change', function () { setTimeout(runAll, 0); });

  // Pre-paint observers on the containers the theme rewrites in place. These fire
  // as microtasks, so the raw value is trimmed before it can be painted.
  var watched = window.WeakSet ? new WeakSet() : null;
  function watchTight() {
    if (!window.MutationObserver) return;
    var targets = document.querySelectorAll(
      '.product-form__variants, .product-form__info-list, .mini-cart, #mini-cart, .line-item-list, .cart__items, .bundle-items, [class*="bundle"]'
    );
    Array.prototype.forEach.call(targets, function (t) {
      if (watched) {
        if (watched.has(t)) return;
        watched.add(t);
      } else if (t.getAttribute('data-fs-watched')) { return; }
      else { t.setAttribute('data-fs-watched', '1'); }

      new MutationObserver(function () { pass(t); })
        .observe(t, { childList: true, subtree: true, characterData: true });
    });
  }

  // Catch wholesale re-renders, and only once parsing is done — attaching this
  // during parse would fire on every appended node and starve rendering.
  function watchLoose() {
    if (!window.MutationObserver || !document.body) return;
    var pending = false;
    new MutationObserver(function () {
      if (running || pending) return;
      pending = true;
      setTimeout(function () { pending = false; runAll(); watchTight(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    // Seed from the variant the page loaded with, so the first colour change
    // already knows which size to carry across.
    var checked = document.querySelector('.block-swatch-list .block-swatch__radio:checked');
    if (checked) wantedSize = strip(checked.value);
    runAll();
    watchTight();
    watchLoose();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
